// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraSerifDisplay_7d2501', '__fedraSerifDisplay_Fallback_7d2501'"},"className":"__className_7d2501","variable":"__variable_7d2501"};